import { createSelector } from 'reselect'
import { State } from 'index'

const brandSelector = (state: State) => state.brand

export const getConfirmBrand = createSelector([brandSelector], (state) => state.confirm)
export const getBrands = createSelector([brandSelector], (state) => state.brands)
